﻿import {DateTime} from "@2d-front-monorepo/core";
import ParkingPrebookingAvailabilityType from "../enums/ParkingPrebookingAvailabilityType";
import {ParkingPrebookingAvailabilityEntry} from "../types/ParkingPrebookingAvailabilityEntry";
import {isAdjacentAcrossMidnight} from "./isAdjacentAcrossMidnight";

export function isDateRangeValid(entries: ParkingPrebookingAvailabilityEntry[], startDate: DateTime, endDate: DateTime, unavailable: Set<string>): boolean {
	if (entries.length === 0) {
		return false;
	}

	const availableEntries = entries.filter(entry =>
		entry.type === ParkingPrebookingAvailabilityType.Available &&
		entry.startDate < endDate &&
		entry.endDate > startDate
	);

	if (availableEntries.length === 0) {
		return false;
	}

	let currentIndex = availableEntries.findIndex(entry =>
		entry.startDate <= startDate && entry.endDate > startDate
	);

	if (currentIndex === -1) {
		return false;
	}

	let currentCoveredUntil = availableEntries[currentIndex].endDate;
	if (currentCoveredUntil >= endDate || isAdjacentAcrossMidnight(currentCoveredUntil, endDate, unavailable)) {
		return true;
	}

	for (let i = currentIndex + 1; i < availableEntries.length; i++) {
		const currentSpan = availableEntries[i];
		const isAdjacent = currentSpan.startDate.equals(currentCoveredUntil) || isAdjacentAcrossMidnight(currentCoveredUntil, currentSpan.startDate, unavailable);

		if (!isAdjacent) {
			return false;
		}

		currentCoveredUntil = currentSpan.endDate;
		if (currentCoveredUntil >= endDate || isAdjacentAcrossMidnight(currentCoveredUntil, endDate, unavailable)) {
			return true;
		}
	}

	return false;
}
